
import {
  WDModalForm,
  WDApi,
  WDActivity
} from 'wd';

export default class WDPasswordRequest extends WDModalForm {

  #submitBtn = null;
  
  constructor()
  {
    super({title:'Reset Your Password'});
    
    this.on('modal:show',() => this.buildForm() );
  };

  buildForm()
  {
    const msg = wdc('<p class="password-reset-message"/>');
    msg.append('Please enter your username or email address below. If found, a message will be sent to your email address with instructions on resetting your password.');

    this.body().prepend(msg);
    
    this.addForm({type:'text',name:'userinfo',placeholder:'Enter your login or email address'});
    this.#submitBtn = this.addButton({label:'Submit Request',theme:'success',click:() => this.submit() });
  };  
  
  submit()
  {
    this.#submitBtn.busy(true);
    
    const p = new WDApi('/passwordrequest');
    p.add(this.serialize());
    p.post().then( data => {

      const m = new WDActivity().showMessage('Your request was submitted. Please check your email for further instructions.');
      m.addButton({label:'Close',theme:'primary',click:() => m.hide() });
      this.hide();
    
    });
    
  };

};

customElements.define('wd-password-request',WDPasswordRequest);
